import React from 'react'
import { Button, Card, Layout, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography

/** صفحة الدعم والمساعدة لتطبيق LeenGo (عربي) — مناسبة لرابط الدعم في App Store. */
export default function Support() {
    return (
        <Layout style={{ minHeight: '100vh', background: '#f4ede3' }}>
            <Layout.Content style={{ padding: 'clamp(16px, 4vw, 32px)', maxWidth: 840, margin: '0 auto', width: '100%' }}>
                <div dir="rtl" lang="ar" style={{ textAlign: 'right' }}>
                    <div style={{ marginBottom: 20 }}>
                        <Link to="/">
                            <Button type="link" style={{ paddingInline: 0 }}>← العودة إلى الرئيسية</Button>
                        </Link>
                    </div>

                    <Card styles={{ body: { padding: 'clamp(20px, 4vw, 32px)' } }}>
                        <Title level={2} style={{ marginTop: 0 }}>الدعم والمساعدة</Title>
                        <Text type="secondary">تطبيق LeenGo — لين غو</Text>
                        <Paragraph style={{ marginTop: 8 }}>
                            <Text strong>آخر تحديث:</Text> ١ أبريل ٢٠٢٦
                        </Paragraph>

                        <Title level={4}>١. مرحباً بك</Title>
                        <Paragraph>
                            هذه الصفحة مخصّصة لمستخدمي تطبيق <Text strong>LeenGo</Text> — تطبيق <Text strong>لين غو</Text> للتسوق والطلبات.
                            هنا تجد طرق التواصل معنا وبعض الإجابات السريعة. إذا احتجت مساعدة بخصوص الطلب أو الحساب،
                            نفضّل التواصل معنا عبر الواتساب أو صفحاتنا الرسمية على وسائل التواصل.
                        </Paragraph>

                        <Title level={4}>٢. التواصل معنا</Title>
                        <Paragraph>يمكنك مراسلتنا عبر أي من القنوات التالية:</Paragraph>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>
                                <Text strong>واتساب:</Text>{' '}
                                <a
                                    href="https://api.whatsapp.com/send/?phone=970595566789&type=phone_number&app_absent=0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    فتح محادثة واتساب
                                </a>
                            </li>
                            <li>
                                <Text strong>فيسبوك:</Text>{' '}
                                <a href="https://www.facebook.com/leenmallps/" target="_blank" rel="noopener noreferrer">
                                    leenmallps
                                </a>
                            </li>
                            <li>
                                <Text strong>إنستغرام:</Text>{' '}
                                <a href="https://www.instagram.com/leen_mall_ps" target="_blank" rel="noopener noreferrer">
                                    @leen_mall_ps
                                </a>
                            </li>
                        </ul>
                        <Paragraph type="secondary" style={{ fontSize: 13 }}>
                            يرجى التواصل فقط عبر الحسابات الرسمية أعلاه لتجنّب الاحتيال.
                        </Paragraph>

                        <Title level={4}>٣. أسئلة شائعة</Title>
                        <Paragraph>
                            <Text strong>كيف أسجّل الدخول؟</Text>
                            <br />
                            استخدم رقم الهاتف المرتبط بحسابك وأدخل رمز التحقق (OTP) المرسل إليك داخل التطبيق.
                        </Paragraph>
                        <Paragraph>
                            <Text strong>لم أستلم إشعاراً بحالة الطلب</Text>
                            <br />
                            تأكد من تفعيل الإشعارات للتطبيق في إعدادات الجهاز. إذا استمرّت المشكلة، راسلنا على الواتساب مع
                            رقم هاتفك المسجّل.
                        </Paragraph>
                        <Paragraph>
                            <Text strong>مشكلة في الطلب أو التوصيل</Text>
                            <br />
                            صوّر رقم الطلب من شاشة «طلباتي» إن أمكن، وتواصل معنا لنتابع معك.
                        </Paragraph>
                        <Paragraph>
                            <Text strong>الموقع الإلكتروني</Text>
                            <br />
                            يمكنك الطلب أيضاً عبر الموقع <Text code>leen-go.com</Text> بنفس الحساب والمنطقة حيث ينطبق ذلك.
                        </Paragraph>

                        <Title level={4}>٤. روابط مفيدة</Title>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>
                                <Link to="/privacy">سياسة الخصوصية</Link>
                            </li>
                            <li>
                                <Link to="/account-deletion">حذف الحساب والبيانات</Link>
                            </li>
                        </ul>

                        <Title level={4}>٥. ملاحظة</Title>
                        <Paragraph style={{ marginBottom: 0 }}>
                            أوقات الرد قد تختلف حسب حجم الطلبات. نسعى للرد في أقرب وقت ممكن على جميع الرسائل الواردة عبر
                            القنوات الرسمية.
                        </Paragraph>
                    </Card>
                </div>
            </Layout.Content>
        </Layout>
    )
}
